import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { mergeClassNames } from '../utils/mergeClassNames.es.js';
import { useEffect } from 'react';
import { ListBoxItem } from 'react-aria-components';
import { Icon } from '@zapier/design-system';
import { useSelectContext } from '../SelectBase/SelectContext.es.js';

const selectItem = "_select-item_hksyq_1";
const styles = {
	selectItem: selectItem
};

const SelectItem = (_a) => {
  var { children, className, isDisabled = false, iconName, size, textValue, value } = _a, props = __rest(_a, ["children", "className", "isDisabled", "iconName", "size", "textValue", "value"]);
  const { registerDisabledItem, size: sizeFromContext } = useSelectContext();
  useEffect(() => {
    if (isDisabled) {
      registerDisabledItem(value || "");
    }
  }, [isDisabled, value, registerDisabledItem]);
  return jsx(ListBoxItem, Object.assign({ className: (renderProps) => mergeClassNames([styles.selectItem, className], renderProps), "data-size": size !== null && size !== void 0 ? size : sizeFromContext, "data-zds": true, id: value, textValue }, props, { children: (renderProps) => jsxs(Fragment, { children: [iconName && jsx(Icon, { name: iconName, size: 16 }), typeof children === "function" ? children(renderProps) : children] }) }));
};

export { SelectItem };
//# sourceMappingURL=SelectItem.es.js.map
